module.exports = __webpack_public_path__ + "img/wines.d138f5b9.png";